import { Box, Button, Typography } from "@mui/material";
import CustomDialog from "../shared/CustomDialog";
import moment from "moment-jalaali";
import { FinancialAssetSubTypeFarsi } from "../../types/FinancialAssets";
import { toToman } from "../../utils/Utils";
import GrowthBadge from "../shared/GrowthBadge";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import { LoadingButton } from "@mui/lab";

const CardItem = (props) => {
  const { title, value, first } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderLeft: !first && ((theme) => `1px solid ${theme.palette.grey[6]}`),
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Box mt={1}>{value}</Box>
    </Box>
  );
};

export function AddOrRemoveFund(props) {
  const {
    open,
    setOpen,
    selectedAutoInvestItem,
    setSelectedItems,
    setAutoInvestmentStatus,
  } = props;

  const { loading, apiCall: deleteAutoInvestmentItem } = useRequest(
    BalootUserAPIs.deleteAutoInvestmentItem
  );

  const onSubmit = () => {
    if (selectedAutoInvestItem.isAdd) {
      setSelectedItems((prev) => {
        return [...prev, selectedAutoInvestItem];
      });
      setOpen(false);
    } else {
      if (selectedAutoInvestItem.id) {
        deleteAutoInvestmentItem({
          data: { id: selectedAutoInvestItem.id },
          onSuccess: () => {
            setSelectedItems((prev) =>
              prev.filter(
                (item) => item.assetId !== selectedAutoInvestItem.assetId
              )
            );
            setAutoInvestmentStatus((prev) => {
              return {
                ...prev,
                items: prev.items.filter(
                  (item) => item.id !== selectedAutoInvestItem.id
                ),
              };
            });
            setOpen(false);
          },
        });
      } else {
        setSelectedItems((prev) =>
          prev.filter((item) => item.assetId !== selectedAutoInvestItem.assetId)
        );
        setOpen(false);
      }
    }
  };

  const itemsRow1 = [
    {
      title: "نوع صندوق",
      value: (
        <Typography variant="subtitle1" color="grey.2">
          {
            FinancialAssetSubTypeFarsi[
              selectedAutoInvestItem.fundInfo.assetSubType
            ]
          }
        </Typography>
      ),
    },
    {
      title: "قیمت هر واحد",
      value: (
        <Typography variant="h6" color="grey.2">{`${toToman(
          selectedAutoInvestItem.fundInfo.purchaseNav
        )} تومان`}</Typography>
      ),
    },
    {
      title: "دوره ماندگاری",
      value: (
        <Typography variant="h6" color="grey.2">
          {selectedAutoInvestItem.fundInfo.holdingPeriod}
        </Typography>
      ),
    },
  ];
  const itemsRow2 = [
    {
      title: "بازده سالانه",
      value: (
        <GrowthBadge rate={selectedAutoInvestItem.fundInfo.yearlyEfficiency} />
      ),
    },
    {
      title: "بازده سه ماهه",
      value: (
        <GrowthBadge
          rate={selectedAutoInvestItem.fundInfo.threeMonthEfficiency}
        />
      ),
    },
    {
      title: "بازده ماهانه",
      value: (
        <GrowthBadge
          rate={selectedAutoInvestItem.fundInfo.oneMonthEfficiency}
        />
      ),
    },
  ];
  return (
    <CustomDialog open={open}>
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            width={56}
            height={56}
            src={selectedAutoInvestItem.fundInfo.iconPath}
          />
          <Typography variant="h4" color="primary.main" mt="16px">
            {selectedAutoInvestItem.fundInfo.name}
          </Typography>
          {selectedAutoInvestItem.fundInfo.nextProfitReturnDate && (
            <Typography variant="subtitle1" color="grey.4" mt="8px">
              {`تاریخ توزیع سود: ${moment(
                selectedAutoInvestItem.fundInfo.nextProfitReturnDate
              ).format("jYYYY/jMM/jDD")} (${
                moment(
                  selectedAutoInvestItem.fundInfo.nextProfitReturnDate
                ).diff(moment(), "day") + 1
              } روز دیگر)`}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            mt: "16px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              minHeight: 70,
            }}
          >
            {itemsRow1.map((item, index) => {
              return (
                <CardItem
                  key={index}
                  title={item.title}
                  value={item.value}
                  first={index === 0}
                />
              );
            })}
          </Box>
          <Box
            sx={{
              display: "flex",
              minHeight: 70,
              borderTop: (theme) => `1px solid ${theme.palette.grey[5]}`,
            }}
          >
            {itemsRow2.map((item, index) => {
              return (
                <CardItem
                  key={index}
                  title={item.title}
                  value={item.value}
                  first={index === 0}
                />
              );
            })}
          </Box>
        </Box>
        <Box
          sx={{
            mt: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {selectedAutoInvestItem.isAdd ? (
            <Button
              onClick={onSubmit}
              size="small"
              variant={"contained"}
              color="primary"
              sx={{
                typography: "h5",
                minWidth: 130,
                color: "common.white",
              }}
            >
              انتخاب
            </Button>
          ) : (
            <LoadingButton
              loading={loading}
              onClick={onSubmit}
              size="small"
              color="error"
              variant={"outlined"}
              sx={{
                typography: "h5",
                minWidth: 130,
              }}
            >
              حذف
            </LoadingButton>
          )}
          <Button
            onClick={() => {
              setOpen(false);
            }}
            size="small"
            variant={"text"}
            sx={{
              mt: 1,
              minWidth: 130,
              color: "grey.4",
            }}
          >
            بستن
          </Button>
        </Box>
      </>
    </CustomDialog>
  );
}
